import { render, staticRenderFns } from "./moduleBase.vue?vue&type=template&id=713dcaec&"
import script from "./moduleBase.vue?vue&type=script&lang=js&"
export * from "./moduleBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports